import React from "react";
import Loading from "./Loading";
import Layout from "./Layout";
import { GKLayoutShell } from "@granular/gds-ux-components";

import { ChildrenProp } from "../types";
import {
  useManageCurrentOperationId,
  useMaybeCurrentOperationId,
} from "../next/hooks";

import { ShellProps } from "./FabricShell";
import EnsureCoreData from "./EnsureCoreData";

const CurrentOperation: React.FC<
  Omit<ShellProps, "UNSAFE_injectedTranslations"> & ChildrenProp
> = (props) => {
  React.useEffect(() => {
    console.debug("[@granular/fabric-core][CurrentOperation] mounted");
  }, []);

  const currentOperationId = useMaybeCurrentOperationId();
  useManageCurrentOperationId({ translateRoutes: props.translateRoutes });

  const { children, ...filteredLayoutProps } = props;

  if (!currentOperationId) {
    console.debug("[@granular/fabric-core][CurrentOperation] Loading", {
      currentOperationId,
    });
    return (
      // Because this is rendering some UI, we need GKLayoutShell
      <GKLayoutShell>
        <Loading useGKContent={true} />
      </GKLayoutShell>
    );
  }

  return (
    <EnsureCoreData isOutsideGKLayoutShell requiredCoreData={{}}>
      <Layout {...filteredLayoutProps}>{children}</Layout>
    </EnsureCoreData>
  );
};

export default CurrentOperation;
